import bugsnag from "@bugsnag/js";
import bugsnagReact from "@bugsnag/plugin-react";
import Amplify from "aws-amplify";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import mixpanel from "mixpanel-browser";
import { ThemeProvider, CssBaseline, createMuiTheme } from "@material-ui/core";
import { StylesProvider } from "@material-ui/styles";
import * as colors from "./styles/colors";

import App from "./App";
import config from "./config";
import store from "./store";
import * as serviceWorker from "./serviceWorker";

import "./index.css";

Amplify.configure({
  Auth: config.cognito,
  ...config.appSync,
  Storage: {
    AWSS3: {
      bucket: config.s3.bucket,
      region: "us-west-2",
    },
  },
});

try {
  mixpanel.init(config.mixpanel.token);
  mixpanel.set_config({ 
    persistence: "localStorage",
    ignore_dnt: true,
    debug: false
  });
  
  window.track = (event, properties) => {
    try {
      mixpanel.track(event, properties);
    } catch (e) {
      console.debug('Mixpanel tracking unavailable');
    }
  };
} catch (e) {
  window.track = () => {};
  console.debug('Mixpanel initialization failed');
}

export const bugsnagClient = bugsnag.start({
  apiKey: "29aaa5602246ce57752f3b59457606bf",
  appVersion: process.env.REACT_APP_VERSION,
  plugins: [new bugsnagReact(React)],
  autoTrackSessions: false,
  endpoints: {
    notify: 'https://notify.bugsnag.com',
    sessions: 'https://sessions.bugsnag.com'
  },
  networkBreadcrumbsEnabled: false,
  maxBreadcrumbs: 20,
  onError: function (event) {
    return process.env.NODE_ENV === 'production';
  }
});

class FallbackErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <div>Something went wrong.</div>;
    }
    return this.props.children;
  }
}

const ErrorBoundary = (() => {
  try {
    return bugsnagClient.getPlugin('react').createErrorBoundary(React);
  } catch (e) {
    console.warn('Failed to initialize Bugsnag error boundary, using fallback');
    return FallbackErrorBoundary;
  }
})();

const kirsTheme = createMuiTheme({
  palette: {
    primary: {
      main: colors.KONTRA_BLUE,
    },
    secondary: {
      main: colors.KONTRA_BLUE_LIGHT,
    },
    error: {
      main: "#DC143C",
    },
  },
});

ReactDOM.render(
  <StylesProvider injectFirst>
    <ThemeProvider theme={kirsTheme}>
      <CssBaseline />
      <ErrorBoundary>
        <Provider store={store}>
          <App />
        </Provider>
      </ErrorBoundary>
    </ThemeProvider>
  </StylesProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
